import React from 'react';
import { Button } from './ui/Button';
import { CheckIcon, DownloadIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="relative bg-[#1a1a2e] text-white overflow-hidden pt-8 pb-10 lg:pt-12 lg:pb-14" data-id="element-68">
      {/* Background Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#1a1a2e] via-[#1a1a2e] to-[#0ABFBC]/20 opacity-60" data-id="element-69" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-70">
        <div className="flex flex-col lg:flex-row items-center gap-6 lg:gap-10" data-id="element-71">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6
        }} className="flex-1 text-center lg:text-left" data-id="element-72">
            <div className="inline-block px-4 py-1.5 rounded-full bg-[#0ABFBC]/10 border border-[#0ABFBC]/30 text-[#0ABFBC] font-semibold text-sm mb-6" data-id="element-73">
              Guía Digital PDF
            </div>

            <h1 className="text-4xl lg:text-5xl xl:text-6xl font-extrabold leading-tight mb-6 font-montserrat" data-id="element-74">
              Recupera el equilibrio digital en tu hogar en solo{' '}
              <span className="text-[#0ABFBC]" data-id="element-75">7 días</span>
            </h1>

            <p className="text-lg lg:text-xl text-gray-300 mb-8 max-w-2xl mx-auto lg:mx-0 font-lato" data-id="element-76">
              Una guía práctica para madres que quieren establecer límites
              saludables sin discusiones constantes ni medidas extremas.
            </p>

            <div className="flex flex-col gap-2 mb-6 max-w-md mx-auto lg:mx-0" data-id="element-77">
              {['Estrategia clara y aplicable', 'Sin prohibiciones radicales', 'Enfoque práctico y realista'].map((item, index) => <div key={index} className="flex items-center gap-3 justify-center lg:justify-start" data-id="element-78">
                  <div className="flex-shrink-0 w-6 h-6 rounded-full bg-[#0ABFBC]/20 flex items-center justify-center" data-id="element-79">
                    <CheckIcon className="w-4 h-4 text-[#0ABFBC]" data-id="element-80" />
                  </div>
                  <span className="text-gray-200 font-medium" data-id="element-81">{item}</span>
                </div>)}
            </div>

            <div className="flex flex-col items-center lg:items-start gap-4" data-id="element-82">
              <Button variant="primary" size="xl" className="w-full sm:w-auto text-lg shadow-orange-500/20" onClick={() => document.getElementById('pricing')?.scrollIntoView({
              behavior: 'smooth'
            })} data-id="element-83">
                Quiero empezar hoy
              </Button>
              <p className="text-sm text-gray-400 flex items-center gap-2" data-id="element-84">
                <DownloadIcon className="w-4 h-4" data-id="element-85" />
                Descarga inmediata en PDF – Acceso instantáneo
              </p>
            </div>
          </motion.div>

          {/* Image Content */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="flex-1 relative" data-id="element-86">
            <div className="relative z-10 transform lg:rotate-2 hover:rotate-0 transition-transform duration-500" data-id="element-87">
              <img src="https://cdn.magicpatterns.com/uploads/97cd2uF6QLY4UAdXHbmZQy/MOCKUP_1.png" alt="El Interruptor Digital - Guía PDF en Tablet" className="w-full max-w-lg mx-auto drop-shadow-2xl" width="512" height="512" fetchPriority="high" data-id="element-88" />
            </div>
            {/* Decorative elements behind image */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] bg-[#0ABFBC]/20 blur-[100px] rounded-full -z-10" data-id="element-89" />
          </motion.div>
        </div>
      </div>
    </section>;
}